export enum RutterCompanyConnectionStatus {
    Pending = 'pending',
    Active = 'active',
    Inactive = 'inactive',
}
